import HttpCliente from "../servicios/HttpCliente";

export const obtenerCentroCostoModal = async (id) => {
    return await HttpCliente.get(`/Contratos/ListaCentroCostoContrato/${id}`)
  };